<template>
  <!-- the space (task 59): personal or a team; shown only to members of a team -->
  <v-menu v-if="teams.length" location="bottom end" offset="4">
    <template #activator="{ props }">
      <v-btn v-bind="props" variant="text" class="mx-1 space-btn" :title="`Пространство: ${currentName}`">
        <v-icon start>{{ current === 'personal' ? 'mdi-account' : 'mdi-account-group' }}</v-icon>
        {{ currentName }}
        <v-icon end>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list density="compact" min-width="240">
      <v-list-subheader>Пространство</v-list-subheader>
      <v-list-item :active="current === 'personal'" prepend-icon="mdi-account" title="Личное" @click="choose('personal')" />
      <v-list-item
        v-for="t in teams"
        :key="t.id"
        :active="current === String(t.id)"
        prepend-icon="mdi-account-group"
        :title="t.name"
        :subtitle="t.role === 'owner' ? 'владелец' : 'участник'"
        @click="choose(String(t.id))"
      />
      <v-divider class="my-1" />
      <v-list-item prepend-icon="mdi-cog-outline" title="Мои команды" to="/teams" />
    </v-list>
  </v-menu>
</template>

<script>
import apiClient from '@/apiClient'
import { currentSpace, setSpace, userKeyOf } from '@/utils/space'

export default {
  name: 'SpaceSwitcher',
  data() {
    return { teams: [], current: 'personal' }
  },
  computed: {
    userKey() {
      return userKeyOf(this.$store.state.userInfo)
    },
    currentName() {
      if (this.current === 'personal') return 'Личное'
      const t = this.teams.find(x => String(x.id) === this.current)
      return t ? t.name : 'Личное'
    },
  },
  watch: {
    // the user is known a moment after the header appears (GET /users/me)
    userKey: { immediate: true, handler(k) { if (k) this.load() } },
  },
  methods: {
    async load() {
      this.current = currentSpace(this.userKey)
      try {
        const { data } = await apiClient.get('/teams')
        this.teams = data.items || []
      } catch (e) {
        // the list is not known now: the space stays as it is
        return
      }
      // a team the user left or was taken out of: back to the personal space
      if (this.current !== 'personal' && !this.teams.some(t => String(t.id) === this.current)) {
        setSpace(this.userKey, 'personal')
        window.location.reload()
      }
    },
    choose(space) {
      if (space === this.current) return
      setSpace(this.userKey, space)
      // the form of a project stays in the space of its project (ProjectForm.vue): switching
      // there opens the projects of the chosen space instead of the same form again
      if (/^\/project\/\d+/.test(window.location.pathname)) {
        window.location.assign('/projects')
        return
      }
      // every list of the page belongs to the space: the page is opened anew in the chosen one
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.space-btn {
  text-transform: none;
  font-weight: 500;
}
</style>
